import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
// import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
// import { Player } from 'ThreeTerminal_pc/video';

import Loadable from 'react-loadable';
// import LazyLoad from '@ifeng-fe/ui_pc_lazyLoad';

// import Player from './player';

import PlayerList from './playlist';
import { formatVideoDuration } from '../../../utils/timeUnit';
import { getVideoRecomlist, getWemediaVideoList } from '../../../../../services/api';
import mockData from './mockData.json';
// import rankingList from '../rankingList';
import NoSSR from 'react-no-ssr';

const Player = Loadable({
    loader: () => import('./player'),
    loading() {
        return <div />;
    },
});

class PlayerBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        playerUtils: PropTypes.object,
        relatedVideosData: PropTypes.object,
        parentColumn: PropTypes.string,
        ads: PropTypes.object,
        minScreen: PropTypes.bool,
        isHitBlack: PropTypes.bool,
        hasRelatedRecommend: PropTypes.bool,
        interact: PropTypes.object,
    };

    state = {
        tempRelatedVideos: [],
        relatedVideos: [],
        videoStream: [],
        insertArr: [2, 5, 8, 11, 15],
    };

    componentDidMount() {
        // console.log(location.href.substring(0, location.href.lastIndexOf('/video/')));
        this.asyncGetVideoRecomlist();
    }

    asyncGetVideoRecomlist = async () => {
        try {
            const { guid, base62Id, title, wemediaEAccountId, vSource, searchPath } = this.props.content;
            const { relatedVideos, videoStream, allVideoStream } = this.props.relatedVideosData;
            const { isHitBlack, hasRelatedRecommend } = this.props;

            this.setState({
                listData: {
                    relatedVideos: [],
                    videoStream: this.state.videoStream,
                },
            });
            // const res = await getVideoRecomlist(guid, title);
            const res = await getVideoRecomlist(base62Id, title);

            // const res = null;
            if ((vSource === 'cmpp' || !searchPath) && wemediaEAccountId) {
                const _res = await getWemediaVideoList(wemediaEAccountId);

                console.log(_res);
                _res.data.unshift(this.props.content);
                this.setState({
                    videoStream: _res.data,
                });
            }

            let tempRelatedVideos = [];

            if (res && res.data) {
                res.data.unshift(this.props.content);
                tempRelatedVideos = res.data;
            } else if (relatedVideos && relatedVideos.length > 1) {
                // 如果接口崩掉急用searchPath查询数据代替推荐接口数据
                // relatedVideos.unshift(this.props.content);
                // console.log(relatedVideos);

                tempRelatedVideos = relatedVideos;
            } else {
                mockData.unshift(this.props.content);
                tempRelatedVideos = allVideoStream;
            }

            if (videoStream && videoStream.length > 1) {
                this.setState({
                    videoStream,
                });
            }

            this.setState({
                tempRelatedVideos,
                listData: {
                    relatedVideos: tempRelatedVideos,
                    videoStream: this.state.videoStream,
                },
            });
        } catch (e) {
            console.error(e);
        }
    };

    // 插入广告
    insertAds(data) {
        const { insertArr } = this.state;

        insertArr.forEach((item, index) => {
            data.splice(item, 0, { type: 'ad', index });
        });
        // console.log(data);

        return data;
    }

    handleClickComment = () => {
        // if (window) window.scroll(0, document.documentElement.scrollHeight - document.documentElement.clientHeight);
    };

    render() {
        // const {  } = this.state;
        const {
            relatedVideosData,
            content,
            parentColumn,
            ads,
            minScreen,
            playerUtils = {},
            isHitBlack,
            interact,
        } = this.props;

        const { allVideoStream } = relatedVideosData;
        const { tempRelatedVideos, videoStream, listData } = this.state;
        const nextVideo = (tempRelatedVideos && tempRelatedVideos[1]) || '';
        const hasShare = !interact.isCloseShare;
        const playermsg = {
            width: 930,
            height: 528,
            autoPlay: true,
            controls: true,
            nextVideoInfo:
                tempRelatedVideos.length > 1
                    ? {
                          thumbnail:
                              nextVideo.posterUrl ||
                              (nextVideo.intelligentImages ? nextVideo.intelligentImages.single_pic : '') ||
                              '',
                          duration: formatVideoDuration(nextVideo.duration),
                          desc: nextVideo.title,
                          nextLink: nextVideo.base62Id
                              ? `${location.href.substring(0, location.href.lastIndexOf('/c/'))}/c/${
                                    nextVideo.base62Id
                                }`
                              : nextVideo.pcUrl,
                      }
                    : '',
            shareItems: ['sina', 'qq', 'qqzone', 'wechat'], // 分别指新浪微博，qq，QQ空间，微信，可选，最多只有这四个
            clickComments: this.handleClickComment,
            allowResize: false,
            ...playerUtils,
            interact,
        };
        // const listData = {
        //     relatedVideos,
        //     videoStream,
        // };

        return (
            <section className={`${styles.playerBox} clearfix`}>
                <section
                    aria-label="视频播放"
                    className={`${styles.playerContainer} ${minScreen ? styles.min_playerContainer : ''}`}
                    style={{ background: `url(${content.posterUrl}) no-repeat` }}>
                    {/* <NoSSR> */}
                    <Player content={{ videoConfig: content, playermsg }} />
                    {/* </NoSSR> */}
                </section>
                {listData &&
                    listData.relatedVideos &&
                    listData.relatedVideos.length > 0 && (
                        <NoSSR>
                            <PlayerList
                                isHitBlack={isHitBlack}
                                content={listData}
                                parentColumn={parentColumn}
                                ad={ads}
                            />
                        </NoSSR>
                    )}
            </section>
        );
    }
}

export default errorBoundary(PlayerBox);
